import axios from 'axios';
import { Auth } from 'aws-amplify';
import { EXPIRED } from '../auth/actions';

import Config from '../../config';

import { CLIENT_USER_DELETE } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

export const api_client_user_delete = (data) => {
    return (dispatch, getState) => {

        Auth.currentSession().then((session) => {

        const token = session && session.idToken.jwtToken;

        var config = { headers: { Authorization: 'Bearer ' + token } };

        return axios.delete(`${Config.API_BASE_URL}/client/${data.clientId}/user2/delete/${data.userId}`, config)
            .then(response => {

                dispatch({
                    type: CLIENT_USER_DELETE,
                    payload: response.data
                });

            })
            .catch(error => {

                dispatch({
                    type: CLIENT_USER_DELETE,
                    payload: {
                        user: {
                            errors: error.response.data
                        }
                    }
                });
            });
}).catch(error => { 
 dispatch({ type: EXPIRED }); 
 }); 
 };
}

export default api_client_user_delete;